import { LegislationRelationModel } from "./../../models/legislation-relation";
import { CICListTabModel } from "./../../models/tabs/cic-list-tab";
import { CICEnabled } from "./../../interfaces/cic-enabled";
import { CICStatus } from "./../../interfaces/cic-status";
import { JudgmentTabState } from "./../../models/tabs/judgment-tab-state";
import { AppEvents } from "./../../../app-events";
import { DocumentEvents } from "./../../helpers/document-events";
import { CaseRelationModel } from "./../../models/case-relation";
import { GenericListTabView } from "./generic-list-tab";
import { GenericListView } from "./generic-list";

export class CICListTabView extends GenericListTabView {

    public model: CICListTabModel;

    public setupModelListeners() {
        super.setupModelListeners();
        this.listenTo(this.model.Data, DocumentEvents.CICEngaged, this.CICEngaged);
        this.listenTo(this.model.Data, DocumentEvents.CICRemoveAll, this.CICConsideredRemoveAll);
        if (this.model.CollectionName.toLowerCase() === "considered" || this.model.CollectionName.toLowerCase() === "legislationconsidered") {
            this.listenTo(this.model.Data, DocumentEvents.DocumentRefreshed, this.requestConsideredCICCounts);
            this.listenTo(this.model.Data, DocumentEvents.FullTextLoaded, this.requestConsideredCICCounts);
            this.listenTo(this.model.Data, DocumentEvents.CICCountsReady, this.updateConsideredCICCounts);
        }
    }

    public events(): Backbone.EventsHash {
        const events = super.events();
        events[`click .context-link`] = (e) => this.CICButtonClick(e);
        events[`click .citing-context-link`] = (e) => this.citingContextButtonClick(e);
        return events;
    }

    public onShow() {
        super.onShow();
        if (this.model.CollectionName.toLowerCase() !== "considered" && this.model.CollectionName.toLowerCase() !== "legislationconsidered") {
            this.updateSubsequentCICCounts();
            this.listenTo(this.model.Data, DocumentEvents.DocumentRefreshed, this.updateSubsequentCICCounts);
        }
        this.appEvents.on(AppEvents.ClearCIC, (options) =>  this.CICClearReceived(options));
    }

    public CICClearReceived(options: any) {
        if (options && options.docKey) {
            if (options.docKey === this.model.Data.Id) {
                this.CICSubsequentRemoveAll();
            }
        }
    }

    private CICConsideredRemoveAll() {
        const $buttons = $(`.context-link`);
        $buttons.attr("class", "btn context-link");
    }

    private CICSubsequentRemoveAll() {
        const $buttons = $(`.citing-context-link`);
        $buttons.attr("class", "btn citing-context-link");
    }

    private CICEngaged(data: CICStatus) {
        const $button = $(`.context-link[data-id="${data.Id}"]`);
        $button.attr("class", `btn context-link ${data.Class}`);

        this.updateDisabledStatusOfNonActiveCICButtons(data.ActiveCount);
    }

    private updateDisabledStatusOfNonActiveCICButtons(activeCount: number) {
        const active = this.$("[class^='btn context-link active-']");
        const maxNumberHighlighted = activeCount >= JudgmentTabState.highlightColors.length;
        this.toggleDisabledStateOfControl(this.$(".context-link").not(active), maxNumberHighlighted);
    }

    private toggleDisabledStateOfControl(e: JQuery, disabled: boolean): void {
        e.toggleClass("disabled", disabled).attr("aria-disabled", disabled.toString());
    }

    private CICButtonClick(e: JQueryEventObject) {
        const $button = $(e.currentTarget);
        if ($button.hasClass("disabled") || $button.hasClass("no-context-link")) {
            return;
        }

        $button.blur();

        const active = $button.attr("class").indexOf("active-") > 0;
        this.model.Data.trigger(DocumentEvents.ToggleCIC, {Active: active, button: $button, EventData: e});
    }

    private requestConsideredCICCounts() {
        const ids = [];
        this.model.RelationCollection.forEach((m: CICEnabled) => {
            ids.push(m.Id);
        });
        this.model.Data.trigger(DocumentEvents.RequestConsideredCICCounts, {tabid: this.model.cid, ids: ids});
    }

    private updateConsideredCICCounts(data) {
        if (data.tabid !== this.model.cid) {
            return;
        }

        if (this.model.CollectionName.toLowerCase() === "considered" || this.model.CollectionName.toLowerCase() === "legislationconsidered") {
            this.model.RelationCollection.forEach((m: CICEnabled) => {
                const entry = _.findWhere(data.counts, {id: m.Id});
                const linksToThisDoc = entry ? (entry as any).count : 0;
                m.HasContext = linksToThisDoc > 0;
                m.PluralContext = linksToThisDoc > 1;
                m.ContextParaCount = linksToThisDoc;
            });
        }
        this.listView.render();
    }

    private updateSubsequentCICCounts() {

        if (this.model.CollectionName.toLowerCase() !== "considered" && this.model.CollectionName.toLowerCase() !== "legislationconsidered") {
            this.model.RelationCollection.forEach((m: CICEnabled) => {
                const linksToThisDoc = m.CitedReferences;
                m.HasContext = linksToThisDoc > 0;
                m.PluralContext = linksToThisDoc > 1;
                m.ContextParaCount = linksToThisDoc;
            });
        }
        this.listView.render();
    }

    private citingContextButtonClick(e: JQueryEventObject): boolean {
        if (e.ctrlKey) { return true; }
        const $button = $(e.currentTarget);
        const count = $button.children(".context-count").text();

        if ($button.hasClass("no-context-link")) {
            e.stopPropagation();
            return false;
        }

        $button.blur();
        const id = $button.attr("data-id");

        this.appEvents.trigger(
            AppEvents.AppInsightsDocumentCitationsInContextClick,
            {RelationType: "Citing", CICDocId: id, Selected: $button.attr("aria-pressed"), ButtonTitle: $button.attr("title")}
        );

       // Turn multiview on
        this.appEvents.trigger(AppEvents.DesktopMode, true);
        _.delay(() => {
            this.appEvents.trigger(AppEvents.DocumentRequested, {
                type: "case",
                title: $button.attr("data-title"),
                section: "fulltext-judgment",
                id,
                applyFilter: true,
                paragraphFilter: {
                    id: this.model.Data.Id,
                    count: count
                },
                caller: this.model.Data.ParentId
            });
        }, 500);
        if ($button.hasClass("active-blue")) {
            $button.removeClass("active-blue");
        } else {
            $button.addClass("active-blue");
        }

        return false;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/cic-list-tab.ts